import React from 'react';
import { Link } from 'react-router-dom';

export default function NotFound() {
  return <main className="flex min-h-screen items-center justify-center bg-slate-950 p-6 text-white">
    <section className="max-w-lg rounded-2xl border border-slate-700 bg-slate-900 p-8">
      <h1 className="text-2xl font-bold">Page not found</h1>
      <p className="mt-4 text-slate-300">That link may be old or incomplete. You can continue with a free career path or return to your saved work.</p>
      <Link to="/roles" className="mt-6 block rounded-lg bg-green-500 p-3 text-center font-semibold text-slate-950">Explore career paths</Link>
      <Link to="/portal" className="mt-4 block text-green-400">Open your Tekyu workspace</Link>
      <a href="https://portal.cyberagoge.com/" className="mt-4 block text-green-400">Cyber Agoge student portal</a>
    </section>
  </main>;
}
